import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TicketsCard from "../components/TicketsCard";
import { useAuth } from "../context/AuthContext";
import { getEvents } from "../firebase/firestoreService";
import "../styles/events.css";

const fmtDate = (ts) => {
  if (!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }) +
    " · " + d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
};

const fromPrice = (event) => {
  const prices = (event.ticketTypes || []).map((t) => t.price).filter((p) => typeof p === "number");
  if (!prices.length) return null;
  return Math.min(...prices);
};

export default function Events({ cartCount, onCartClick }) {
  const navigate = useNavigate();
  const { user, openSignIn } = useAuth();
  const [tab,     setTab]     = useState("browse");
  const [events,  setEvents]  = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEvents().then((all) => {
      const now = new Date();
      setEvents(all.filter((e) => {
        if (e.status !== "active") return false;
        const d = e.eventDate?.toDate ? e.eventDate.toDate() : new Date(e.eventDate);
        return d >= now;
      }));
      setLoading(false);
    });
  }, []);

  return (
    <div className="events-page">
      <Navbar cartCount={cartCount || 0} onCartClick={onCartClick || (() => {})} />

      <main className="events-page__main">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 28 }}>
          <h1 className="events-page__title" style={{ marginBottom: 0 }}>Events</h1>
          <div style={{ display: "flex", gap: 6 }}>
            {[{ key: "browse", label: "Browse" }, { key: "tickets", label: "My Tickets" }].map((t) => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                style={{
                  padding: "6px 18px", fontSize: 12, fontWeight: 600,
                  fontFamily: "inherit", borderRadius: 20, border: "1px solid", cursor: "pointer",
                  transition: "all .15s",
                  borderColor: tab === t.key ? "#1a1a1a" : "#ddd",
                  background:  tab === t.key ? "#1a1a1a" : "#fff",
                  color:       tab === t.key ? "#fff"    : "#888",
                }}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {tab === "browse" ? (
          loading ? (
            <div className="events-page__loading">
              <div className="events-page__spinner" />
              <p>Loading events…</p>
            </div>
          ) : events.length === 0 ? (
            <p className="events-page__empty">No upcoming events right now — check back soon.</p>
          ) : (
            <div className="events-grid">
              {events.map((event) => {
                const price = fromPrice(event);
                return (
                  <div key={event.id} className="event-card" onClick={() => navigate(`/events/${event.id}`)}>
                    {event.image && <img className="event-card__img" src={event.image} alt={event.name} />}
                    <div className="event-card__body">
                      <p className="event-card__date">{fmtDate(event.eventDate)}</p>
                      <p className="event-card__name">{event.name}</p>
                      {event.venue && <p className="event-card__venue">{event.venue}</p>}
                      {price !== null && <p className="event-card__price">From MK {price.toLocaleString()}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          )
        ) : !user ? (
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <p style={{ fontSize: 13, color: "#888", marginBottom: 16 }}>Sign in to see your tickets.</p>
            <button className="event-detail__bar-btn" style={{ position: "static" }} onClick={() => openSignIn()}>
              Sign In
            </button>
          </div>
        ) : (
          <div style={{ maxWidth: 480 }}>
            <TicketsCard userId={user.uid} />
          </div>
        )}
      </main>
    </div>
  );
}
